import { Component } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { PresetCervino } from '../assets/themes/cervino-theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
    constructor(private primeng: PrimeNG, private translateService: TranslateService) { }

    ngOnInit() {
        this.primeng.ripple.set(true);

        this.primeng.theme.set({
            preset: PresetCervino,
            options: {
                darkModeSelector: false,
                cssLayer: false
            }
        });

        this.translateService.setDefaultLang('es');
        this.translateService.use('es');

        this.translateService.get('primeng').subscribe(res => {
            this.primeng.setTranslation(res);
        });
    }
}
